/* 🤖 this file was generated by svg-to-ts */
export const matIconAdd: {
  name: 'add';
  data: string;
} = {
  name: 'add',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>`
};
